import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import { styled, Typography } from "@mui/material";
import { memo } from "react";
const BoxWrapperstyle = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  backgroundColor: theme.palette.background.default,
  border: `2px solid ${theme.palette.divider}`,
  borderRadius: "6px",
  padding: "30px 35px",
  "@media screen and (max-width:600px)": {
    width: "90%",
  },
  "& .topContent": {
    marginBottom: "30px",
    "& h4": { fontSize: "22px", marginBottom: "8px", color: theme.palette.text.primary, fontWeight: 600 },
    "& p": {
      fontSize: "16px",
      marginBottom: "8px",
      color: theme.palette.text.primary,
      "& span": {
        color: theme.palette.primary.main,
        fontWeight: 700,
        fontSize: "16px",
      },
    },
  },
  "& .BtnWrapper": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "12px",
    "& button": {
      textTransform: "none",
      backgroundColor: theme.palette.primary.main,
      color: "#ffffff",
      borderRadius: "5px",
      boxShadow: "none",
      padding: "7px 22px",
      whiteSpace: "nowrap",
      width: "100%",
      transition: "0.3s all",
      "&:focus": {
        outline: "none",
      },
      "&:hover": {
        opacity: "0.9",
      },
      "&.OutlineBtn": {
        color: theme.palette.primary.main,
        backgroundColor: "transparent",
        border: `2px solid ${theme.palette.primary.main}`,
        padding: "6px 22px",
        "&:hover": {
          backgroundColor: theme.palette.primary.main,
          color: "#fff",
        },
      },
    },
  },
}));
function DeletePopup({ open, setOpen, handleDelete, msg }) {
  const handleClosePopup = () => {
    setOpen(false);
  };
  return (
    <Modal open={open} onClose={handleClosePopup} aria-labelledby="child-modal-title" aria-describedby="child-modal-description">
      <BoxWrapperstyle>
        <Box className="topContent">
          <Typography component="h4">Delete</Typography>
          <Typography component="p">
            Are you sure you want to delete {msg && `this ticket`} <Typography component="span">{msg && `${msg}`}</Typography> ?
          </Typography>
        </Box>
        <Box className="BtnWrapper">
          <Button onClick={handleDelete}>Delete</Button>
          <Button className="OutlineBtn" onClick={handleClosePopup}>
            Cancel
          </Button>
        </Box>
      </BoxWrapperstyle>
    </Modal>
  );
}

export default memo(DeletePopup);
